const KEYS = {
    DATASET: 'wizard-dataset',
    DISCOVERY: 'wizard-discovery',
    QUERY: 'wizard-query',
}

export default {
    KEYS,
}
